module.exports = __webpack_public_path__ + "static/media/2.744e77bb.png";